import { useQuery } from '@tanstack/react-query'
import type { AdminCardRatingsResponseDto } from '@lunary/api-client'
import { api } from '../../shared/api/client'
import type { PeriodDays } from '../overview/queries'

function range(days: PeriodDays): { from: string; to: string } {
  const now = Date.now() + 3 * 3_600_000
  const to = new Date(now).toISOString().slice(0, 10)
  const from = new Date(now - (days - 1) * 86_400_000).toISOString().slice(0, 10)
  return { from, to }
}

export function useCardRatings(days: PeriodDays, enabled: boolean) {
  return useQuery({
    queryKey: ['admin-card-ratings', days],
    queryFn: () => api.get<AdminCardRatingsResponseDto>('/admin/card-ratings', { query: range(days) }),
    enabled,
    staleTime: 60_000,
  })
}
